<template>
  <div class="content" id="body">
    <div class="container-fluid">
      <open-report
        v-for="(report, index) in inUseReports"
        :key="index"
        :object="report">
      </open-report>
      <transition name="fade" mode="out-in">
        <!-- your content here -->
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>
<script>
  import OpenReport from '@/components/displays/OpenReport'
  import {
    GET_IN_USE_REPORTS
  } from '@/vuex/types'
  import {
    mapGetters
  } from 'vuex'
  export default {
    name: 'Content',
    async mounted () {
      await this.$store.dispatch(GET_IN_USE_REPORTS)
    },
    components: {
      OpenReport
    },
    watch: {
      async $route () {
        await this.$store.dispatch(GET_IN_USE_REPORTS)
      }
    },
    computed: {
      ...mapGetters([
        'inUseReports'
      ])
    }
  }
</script>

<style>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .1s
  }
  .fade-enter,
  .fade-leave-to
  /* .fade-leave-active in <2.1.8 */

  {
    opacity: 0
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/Content.vue